import React, { useState, useEffect } from "react";
import "../assets/css/hero.css";
import bg_video from "../assets/videos/bootcamp-modif.mp4";
import small_x from "../assets/images/small_plus.png";
import big_x from "../assets/images/big_PLUS.png";

const Hero = ({ middleRef }) => {
  const scrollToMiddle = () => {
      middleRef.current.scrollIntoView({ behavior: "smooth" });
  };
  const [autoCount, setAutoCount] = useState({});

  useEffect(() => {
    spans.forEach((span) => {
      const { id, stop, speed } = span;

      let currentCount = stop - stop;
      const counter = setInterval(() => {
        if (currentCount < stop) {
          currentCount += 1;
          setAutoCount((prevCount) => ({ ...prevCount, [id]: currentCount }));
        } else {
          clearInterval(counter);
        }
      }, speed);
      return () => clearInterval(counter);
    });
  }, []);

  return (
    <div className="hero-container">
      {/* background for desktop screen size */}
      <div className="hero-bg-background-video">
        <video autoPlay loop muted playsInline className="bg-video">
          <source src={bg_video} type="video/mp4"></source>
        </video>
      </div>
      {/* content */}
      <div className="hero-overlay-container">
        <div className="hero-item">
          <div className="hero-content">
            <div className="hero-card">
              <div className="hero-content-col">
                <h1>Become a World-Class Tech Talent</h1>
                <p>
                  {" "}
                  Join thousands of learners transforming their careers through
                  our intensive bootcamps
                </p>
                <button onClick={scrollToMiddle} className="btn5">
                  Get Started
                </button>
              </div>
              <div className="small-x">
                <img src={small_x} alt="small icon x" />
              </div>
            </div>
          </div>
          <div className="big-x">
            <img src={big_x} alt="small icon x" />
          </div>
        </div>
        <div className="hero-bottom">
          <div className="hero-bottom-content">
            {spans.map((item, index) => (
              <div key={index} className="hero-bottom-col">
                <h2>
                  {item.id <= 3
                    ? autoCount[item.id] 
                    : autoCount[item.id] + "%"}
                </h2>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
const spans = [
  { id: 1, stop: 2000, speed: 2.5, text: "Trained Students" },
  { id: 2, stop: 50, speed: 100, text: "Expert Trainers" },
  { id: 3, stop: 30, speed: 50, text: "Tech Companies" },
  { id: 4, stop: 95, speed: 52.63, text: "Success Rate" },
];
export default Hero;
